import React from 'react';
import './styles.scss';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const ErrorComponent = () => {
  return (
    <div className="error-component">
      <WarningAmberIcon />
      <h1>Error loading the chart, please try again later...</h1>
    </div>
  );
};

export default ErrorComponent;
